import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import {Provider} from 'react-redux';
import {Router} from 'react-router';

import {routes} from './router/routes';
import {history} from './router/history';
import {init} from './state/configureStore';
import './index.css';

ReactGA.initialize('UA-83142917-1');

const store = init();

ReactDOM.render(
  <Provider store={store} >
    <Router
      history={history}
      routes={routes}
    />
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js